import {DOCUMENTS_TYPES_REQUEST, DOCUMENTS_TYPES, DOCUMENTS_TYPES_FAIL} from "../store/config";

const documentsTypesInit = {
	isFetching: false,
	list: [],
	permissions: [],
	error: undefined,
	timestamp: undefined
}

const documents_types = (state = documentsTypesInit, action) => {
	switch (action.type) {
		case DOCUMENTS_TYPES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case DOCUMENTS_TYPES:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				permissions: action.permissions,
				timestamp: action.permissions
			}
		case DOCUMENTS_TYPES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default documents_types;


// WEBPACK FOOTER //
// ./src/reducers/documents_types.js